import styled from 'styled-components'

export const ContactIcon = styled.span`
  color: ${ (props) => props.theme.colors['icon-grau1'] };
  margin-right: 20px;
`
export const FacilityInformation = styled.div`
  margin-bottom: 20px;

  .facility-data {
    width: 100%;
    max-width: 750px;

    .facility-value-col {
      min-width: 175px;
    }
  }
`
